import React from 'react'
import PropTypes from 'prop-types'
import { __ } from '@wordpress/i18n'
import Button from 'scripts/components/Button/component'
import globalData from 'scripts/shared/globalData'

import './styles.scss'

const { loggedIn, loginUrl, logoutUrl, signupUrl } = globalData

const LoginForm = ({ title }) => {
  return (
    <div className="login-form">
      {!loggedIn ? (
        <>
          {title && <div className={'login-form__title'}>{title}</div>}

          <Button style={'primary'} url={loginUrl}>
            {__('Anmelden', 'dhsv_theme')}
          </Button>

          <Button style={'light'} url={signupUrl}>
            {__('Registrieren', 'dhsv_theme')}
          </Button>
        </>
      ) : (
        <Button style={'primary'} url={logoutUrl}>
          {__('Abmelden', 'dhsv_theme')}
        </Button>
      )}
    </div>
  )
}

LoginForm.propTypes = {
  title: PropTypes.string,
}

export default LoginForm
